module.exports = __webpack_public_path__ + "img/dr_12.5dbae14b.png";